const en = {
  noPartsAdded: 'No parts added yet.',
  part: 'Part',
  color: 'Color',
  qty: 'Qty',
};

const de = {
  noPartsAdded: 'Noch keine Teile hinzugefügt.',
  part: 'Teil',
  color: 'Farbe',
  qty: 'Menge',
};

const partsListTable = { en, de };
export default partsListTable;
